import { render, staticRenderFns } from "./award.vue?vue&type=template&id=bc75f798&scoped=true&"
import script from "./award.vue?vue&type=script&lang=js&"
export * from "./award.vue?vue&type=script&lang=js&"
import style0 from "./award.vue?vue&type=style&index=0&id=bc75f798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc75f798",
  null
  
)

export default component.exports